import { axios } from '@Root/API'

export const getAll = params => {
	return axios.get('all-users', { params })
}
